import { useLibrary } from '@/hooks/library';
import axios from 'axios';
import { createContext, useEffect, useState } from 'react';
import DeleteFileModal from './modal-delete-file';
import MoveModal from './modal-move';
import RenameModal from './modal-rename';
import ShareModal from './modal-share';

export const LibraryContext = createContext();

export default function LibraryContextProvider({ children }) {
   const [view, setView] = useState('grid');
   const [selectedLibrary, setSelectedLibrary] = useState(null);
   const [folderId, setFolderId] = useState(null);
   const [shared, setShared] = useState(false);
   const [deleteModalOpen, setDeleteModalOpen] = useState(false);
   const [renameModalOpen, setRenameModalOpen] = useState(false);
   const [moveModalOpen, setMoveModalOpen] = useState(false);
   const [shareModalOpen, setShareModalOpen] = useState(false);
   const [uploadFileList, setUploadFileList] = useState([]);
   const [uploadProgress, setUploadProgress] = useState(0);
   const library = useLibrary(folderId, shared);

   useEffect(() => {
      if (uploadFileList.length > 0) {
         // calculate progress percentage for all files
         const percentage = Math.round(
            uploadFileList.reduce((acc, file) => acc + file.percent, 0) / uploadFileList.length
         );
         setUploadProgress(percentage);
      } else {
         setUploadProgress(0);
      }
   }, [uploadFileList]);

   const renameFile = async (fileId, newName, extension) => {
      try {
         await axios.patch(`/api/library/file/${fileId}`, {
            name: newName,
            extension: extension,
         });
         library.mutate();
      } catch (error) {
         throw new Error(error.response?.data?.message || 'Failed to rename file');
      }
   };

   const value = {
      library,
      view,
      setFolderId,
      shared,
      setShared,
      setView,
      selectedLibrary,
      setSelectedLibrary,
      setDeleteModalOpen,
      setRenameModalOpen,
      setMoveModalOpen,
      setShareModalOpen,
      uploadFileList,
      setUploadFileList,
      uploadProgress,
      renameFile,
   };

   return (
      <LibraryContext.Provider value={value}>
         <DeleteFileModal open={deleteModalOpen} setOpen={setDeleteModalOpen} />
         <RenameModal open={renameModalOpen} setOpen={setRenameModalOpen} />
         <MoveModal open={moveModalOpen} setOpen={setMoveModalOpen} />
         <ShareModal open={shareModalOpen} setOpen={setShareModalOpen} />

         {children}
      </LibraryContext.Provider>
   );
}
